import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ConfigService } from '@cue-admin/config';

@Injectable({
  providedIn: 'root',
})
export class BasicAuthenticationGuard {
  router = inject(Router);
  private configService = inject(ConfigService);

  canActivate(): boolean | Observable<boolean> | Promise<boolean> {
    if (!this.configService.requiredValue.basicAuthentication) {
      this.router.navigate(['account/login']);
    }
    return this.configService.requiredValue.basicAuthentication;
  }
}
